/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyShipmentSummary
 */
export interface CompanyShipmentSummary {
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  billOfLadingNumber?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyShipmentSummary
   */
  bookedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipFromName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipFromAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipFromCity?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipFromState?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipFromPostal?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipToName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipToAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipToCity?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipToState?: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  shipToPostal?: string | null;
  /**
   *
   * @type {number}
   * @memberof CompanyShipmentSummary
   */
  totalPallets?: number | null;
  /**
   *
   * @type {number}
   * @memberof CompanyShipmentSummary
   */
  totalWeightLbs?: number | null;
  /**
   *
   * @type {string}
   * @memberof CompanyShipmentSummary
   */
  palletDimensions?: string | null;
  /**
   *
   * @type {number}
   * @memberof CompanyShipmentSummary
   */
  totalCost?: number | null;
}

/**
 * Check if a given object implements the CompanyShipmentSummary interface.
 */
export function instanceOfCompanyShipmentSummary(
  value: object,
): value is CompanyShipmentSummary {
  return true;
}

export function CompanyShipmentSummaryFromJSON(
  json: any,
): CompanyShipmentSummary {
  return CompanyShipmentSummaryFromJSONTyped(json, false);
}

export function CompanyShipmentSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyShipmentSummary {
  if (json == null) {
    return json;
  }
  return {
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    bookedAt: json["bookedAt"] == null ? undefined : json["bookedAt"],
    shipFromName:
      json["shipFromName"] == null ? undefined : json["shipFromName"],
    shipFromAddress:
      json["shipFromAddress"] == null ? undefined : json["shipFromAddress"],
    shipFromCity:
      json["shipFromCity"] == null ? undefined : json["shipFromCity"],
    shipFromState:
      json["shipFromState"] == null ? undefined : json["shipFromState"],
    shipFromPostal:
      json["shipFromPostal"] == null ? undefined : json["shipFromPostal"],
    shipToName: json["shipToName"] == null ? undefined : json["shipToName"],
    shipToAddress:
      json["shipToAddress"] == null ? undefined : json["shipToAddress"],
    shipToCity: json["shipToCity"] == null ? undefined : json["shipToCity"],
    shipToState: json["shipToState"] == null ? undefined : json["shipToState"],
    shipToPostal:
      json["shipToPostal"] == null ? undefined : json["shipToPostal"],
    totalPallets:
      json["totalPallets"] == null ? undefined : json["totalPallets"],
    totalWeightLbs:
      json["totalWeightLbs"] == null ? undefined : json["totalWeightLbs"],
    palletDimensions:
      json["palletDimensions"] == null ? undefined : json["palletDimensions"],
    totalCost: json["totalCost"] == null ? undefined : json["totalCost"],
  };
}

export function CompanyShipmentSummaryToJSON(
  json: any,
): CompanyShipmentSummary {
  return CompanyShipmentSummaryToJSONTyped(json, false);
}

export function CompanyShipmentSummaryToJSONTyped(
  value?: CompanyShipmentSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    billOfLadingNumber: value["billOfLadingNumber"],
    bookedAt: value["bookedAt"],
    shipFromName: value["shipFromName"],
    shipFromAddress: value["shipFromAddress"],
    shipFromCity: value["shipFromCity"],
    shipFromState: value["shipFromState"],
    shipFromPostal: value["shipFromPostal"],
    shipToName: value["shipToName"],
    shipToAddress: value["shipToAddress"],
    shipToCity: value["shipToCity"],
    shipToState: value["shipToState"],
    shipToPostal: value["shipToPostal"],
    totalPallets: value["totalPallets"],
    totalWeightLbs: value["totalWeightLbs"],
    palletDimensions: value["palletDimensions"],
    totalCost: value["totalCost"],
  };
}
